import { type InputLocationProps } from 'hb-react/shared/components/DesignSystem/Inputs/InputLocation/types';

import BingSearch from '../engines/bing';
import GoogleSearch from '../engines/google';

export const getEngine = (providerName: InputLocationProps['providerName']) => {
  switch (providerName) {
    case 'google':
      return GoogleSearch;
    case 'bing':
      return BingSearch;
    default:
      throw new Error('Invalid provider name');
  }
};
